import { isBrowser, isString } from './../is';

// SSR 环境下降级为空操作，避免服务端访问 window 报错
const STORAGE = isBrowser
  ? localStorage
  : ({ getItem: () => {}, setItem: () => {} } as unknown as Storage);
const SESSION = isBrowser
  ? sessionStorage
  : ({ getItem: () => {}, setItem: () => {} } as unknown as Storage);

function serialize(v: unknown): string {
  return JSON.stringify(v);
}

function deserialize(v: string | null) {
  if (!isString(v)) {
    return undefined;
  }
  try {
    return JSON.parse(v);
  } catch (e) {
    return v || undefined;
  }
}

/**
 * localStorage / sessionStorage 的统一封装，自动序列化/反序列化 JSON。
 * get/getSession 在键不存在时返回传入的默认值 def。
 */
export const storage = {
  /** 将值序列化后写入 localStorage */
  set(key: string, val: unknown): void {
    STORAGE?.setItem(key, serialize(val));
  },
  /** 从 localStorage 读取并反序列化，键不存在时返回 def */
  get(key: string, def: unknown): unknown {
    const val = deserialize(STORAGE?.getItem(key));
    return val === undefined ? def : val;
  },
  /** 从 localStorage 删除指定键 */
  remove(key: string): void {
    STORAGE?.removeItem(key);
  },
  /** 将值序列化后写入 sessionStorage */
  setSession(key: string, val: unknown): void {
    SESSION?.setItem(key, serialize(val));
  },
  /** 从 sessionStorage 读取并反序列化，键不存在时返回 def */
  getSession(key: string, def: unknown): unknown {
    const val = deserialize(SESSION?.getItem(key));
    return val === undefined ? def : val;
  },
  /** 从 sessionStorage 删除指定键 */
  removeSession(key: string): void {
    SESSION?.removeItem(key);
  },
};
